import { useEffect, useState } from 'react';
import { GroupService } from '../../Services/GroupService';
import { WebApiMemberDtoMemberListResultDto, WebApiModelsEmailTemplate, WebApiServicesDataTransferObjectsGroupServiceGroupResultDto } from '../../Repository/eventbookyapi';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import { EmailForm } from '../../Components/Users/EmailForm';
import LeftMenu from '../Users/LeftMenu';
import { MemberService } from '../../Services/MemberService';
import { EmailFormType } from '../../Types/EmailFormType';
import { EmailTemplateService } from '../../Services/EmailTemplateService';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { AddMultiplePaymentLinksForm } from '../../Components/Users/AddMultiplePaymentLinks';

const AdminCreatePaymentLinks = () => {
  const [groups, setGroups] = useState([] as WebApiServicesDataTransferObjectsGroupServiceGroupResultDto[]);
  const [selectedGroup, setSelectedGroup] = useState({} as WebApiServicesDataTransferObjectsGroupServiceGroupResultDto);
  const [memberResult, setMemberResult] = useState({} as WebApiMemberDtoMemberListResultDto);
  const [emailTemplates, setEmailTemplates] = useState([] as WebApiModelsEmailTemplate[]);

  const { user } = useAuth();
  const GetText = TextService.GetText;

  useEffect(() => {
    GroupService.GetGroupsIncludingAllMembers().then(result => {

      result.forEach(element => {
        if (element.isDefaultGroup) {
          element.name = GetText("MemberList_DefaultAllMembersName");
        }
      });
      setGroups(result);

      if (result.length > 0) {
        setSelectedGroup(result[0]);
      }
    });

    MemberService.GetAllMembers().then(result => {
      setMemberResult(result);
    });

    EmailTemplateService.GetTemplates().then(result => {
      setEmailTemplates(result);
    });
  }, []);

  return <LayoutLeftMenu title={GetText("AdminCreatePaymentLinks_SendMailTitle")} menu={<LeftMenu selected={"sendEmail"} />}>
    Här kan du skapa flera betallänkar samtidigt. T.ex. om du vill välja ut vissa medlemsgrupper som har samma inbetalningsbelopp.
    <AddMultiplePaymentLinksForm user={user} groups={groups} emailTemplates={emailTemplates} memberResult={memberResult} type={EmailFormType.EmailFormByGroup} />
  </LayoutLeftMenu>
};

export default AdminCreatePaymentLinks;